import { render, staticRenderFns } from "./RiasecView.vue?vue&type=template&id=47f4f243&scoped=true&"
import script from "./RiasecView.vue?vue&type=script&lang=js&"
export * from "./RiasecView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4f243",
  null
  
)

export default component.exports